import NavigationHeader from '../layouts/NavigationHeader/NavigationHeader.esm.js';
import { ContentfulModels } from '@invitae/contentful-types';
import GlobalFooter from '../components/footers/GlobalFooter/GlobalFooter.esm.js';
import NavigationElement from '../components/headers/components/NavigationElement/NavigationElement.esm.js';
import NavigationElementL2 from '../components/headers/components/NavigationElement/NavigationElementL2/NavigationElementL2.esm.js';
import NotificationBanner from '../components/NotificationBanner/NotificationBanner.esm.js';

var _a;
var navigationComponentsMap = (_a = {},
    _a[ContentfulModels.navigationHeader] = NavigationHeader,
    _a[ContentfulModels.navigationL1] = NavigationElement,
    _a[ContentfulModels.navigationL2] = NavigationElementL2,
    _a[ContentfulModels.notificationBanner] = NotificationBanner,
    _a[ContentfulModels.layoutFooter] = GlobalFooter,
    _a);

export { navigationComponentsMap as default };
//# sourceMappingURL=defaultMap.esm.js.map
